import { Utilities } from 'core/domains';
import type { Combo } from 'core/domains';

export const initialState: Combo = {
  data: {
    available: false,
    canAddCombo: false,
    choices: [],
    comboCode: 0,
    image: '',
    name: '',
    products: [],
    quantity: 0,
    price: {
      maxPrice: '',
      maxPriceNum: 0,
      price: '',
      priceNum: 0,
      profit: '',
      profitNum: 0,
    },
  },
  isRunning: false,
  message: '',
  status: Utilities.STATUS.IDLE,
};
